import React from 'react';

const DamageCalculator = ({ stats, fruit, weapon, damageOutput, darkMode }) => {
  const cardClass = darkMode 
    ? 'bg-card-dark shadow-card-dark border border-gray-700' 
    : 'bg-white shadow-card-light';
  
  const resultClass = darkMode 
    ? 'bg-green-900/30 border-green-800 text-green-300' 
    : 'bg-green-50 border-green-200 text-green-800';
    
  const textClass = darkMode 
    ? 'text-gray-300' 
    : 'text-gray-600';
    
  const headingClass = darkMode 
    ? 'text-gray-100' 
    : 'text-gray-900';
    
  return (
    <div className={`p-6 rounded-lg transition-theme duration-300 ease-in-out ${cardClass}`}>
      <h2 className={`text-2xl font-bold mb-4 ${headingClass}`}>Damage Output</h2>
      
      {!damageOutput ? (
        <div className="text-center py-8">
          <svg className={`mx-auto h-12 w-12 ${darkMode ? 'text-gray-600' : 'text-gray-400'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13 10V3L4 14h7v7l9-11h-7z" />
          </svg>
          <p className={`mt-2 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
            Click "Calculate Damage" to see your damage output.
          </p>
        </div>
      ) : (
        <div>
          <div className={`p-4 rounded-lg border mb-4 ${resultClass}`}>
            <h3 className={`text-xl font-bold ${darkMode ? 'text-green-300' : 'text-green-800'}`}>
              Total Damage: {damageOutput.total}
            </h3>
          </div>
          
          <div className="space-y-2">
            <h4 className={`font-semibold ${headingClass}`}>Damage Breakdown:</h4>
            
            <div className={`flex justify-between py-2 border-b ${darkMode ? 'border-gray-700' : 'border-gray-200'}`}>
              <span className={textClass}>Strength Contribution:</span>
              <span className={`font-semibold ${headingClass}`}>{damageOutput.breakdown.strength}</span>
            </div>
            
            {fruit && (
              <div className={`flex justify-between py-2 border-b ${darkMode ? 'border-gray-700' : 'border-gray-200'}`}>
                <span className={textClass}>Fruit Contribution:</span>
                <span className={`font-semibold ${headingClass}`}>{damageOutput.breakdown.fruit}</span>
              </div>
            )}
            
            {weapon && (
              <div className={`flex justify-between py-2 border-b ${darkMode ? 'border-gray-700' : 'border-gray-200'}`}>
                <span className={textClass}>Weapon Contribution:</span>
                <span className={`font-semibold ${headingClass}`}>{damageOutput.breakdown.weapon}</span>
              </div>
            )}
          </div>
          
          <div className={`mt-4 pt-4 border-t ${darkMode ? 'border-gray-700' : 'border-gray-200'}`}>
            <h4 className={`font-semibold mb-2 ${headingClass}`}>Factors Considered:</h4>
            <ul className={`list-disc list-inside text-sm ${textClass}`}>
              <li>Base strength multiplier (0.8x)</li>
              {fruit && <li>Fruit mastery multiplier (1.5x)</li>}
              {weapon && <li>Weapon mastery multiplier (1.2x)</li>}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default DamageCalculator;
